import React from 'react'
import {Chart} from 'react-stockcharts'
import {RSISeries, MACDSeries, LineSeries} from 'react-stockcharts/lib/series'
import {YAxis} from 'react-stockcharts/lib/axes'
import {MouseCoordinateY} from 'react-stockcharts/lib/coordinates'
import {schemeCategory10} from 'd3-scale'
import {format} from 'd3-format'
import {Brush} from 'react-stockcharts/lib/interactive'

import {Tooltip} from './Tooltip'

export const Indicators = ({indicators, showModal, gridWidth, yGrid, marginTop, brushEnabled, handleBrush}) => (
  indicators.map((indicator, index) => {
    if (!indicator.calc && !indicator.loaded) {
      return
    }

    const height = 135
    const yOffset = 308 + 75 + (height + 80)*index

    let {ident, label} = indicator
    if (!ident) {
      ident = label
    }
    if (!label) {
      label = ident
    }

    const syntax = ident.toLowerCase()
    if (label.indexOf('_') > -1) {
      label = label.split('_').map(word => word.slice(0,1) + word.slice(1).toLowerCase()).join(' ')
    }

    let series = getSeries(ident, syntax, index)

    const tooltip = Tooltip({
      indicator,
      showModal,
      gridWidth,
      marginTop,
      index
    })

    return(
      <Chart
        key={ident}
        id={ident}
        yExtents={getYExtents(ident, syntax)}
        height={height}
        origin={[0,yOffset]}
      >
        {ident === 'RSI'
          ? <YAxis
            axisAt='right'
            orient='right'
            tickValues={[30, 50, 70]}
            innerTickSize={0}
            fontFamily='GothamHTF'
            tickStroke='#d3d3d3'
            fontSize={12}
          />
          : <YAxis
            axisAt='right'
            orient='right'
            ticks={3}
            fontFamily='GothamHTF'
            tickStroke='#d3d3d3'
            tickFormat={d => Math.abs(d) > 1 ? format('.4s')(d) : format('.4r')(d)}
            fontSize={12}
            {...yGrid}
          />
        }
        <MouseCoordinateY
          at='right'
          orient='right'
          displayFormat={d => Math.abs(d) < 1 ? format('.4r')(d) : format('.4s')(d)}
          fontFamily='GothamHTF'
          rectWidth={65}
          arrowWidth={10}
        />
        {brushEnabled &&
          <Brush
            enabled={brushEnabled}
            type='2D'
            onBrush={handleBrush}
          />
        }
        {series}
        {tooltip}
      </Chart>
    )
  })
)

const getSeries = (ident, syntax, index) => {
  if (ident === 'RSI') {
    return <RSISeries yAccessor={d => d.rsi}/>
  } else if (ident === 'MACD') {
    return <MACDSeries yAccessor={d => d.macd} {...macdAppearance}/>
  } else {
    return <LineSeries yAccessor={d => d[syntax]} stroke={schemeCategory10[index]}/>
  }
}

const getYExtents = (ident, syntax) => {
  if (ident === 'RSI') {
    return [0,100]
  }
  return d => d[syntax]
}

const macdAppearance = {
  stroke: {
    macd: '#FF0000',
    signal: '#00F300',
  },
  fill: {
    divergence: '#4682B4'
  }
}
